import { deriveProgrammeWorkoutProgress } from 'src/hook/programme-workout-progress-derive'
import { useProgrammeWorkoutProgressData } from 'src/hook/use-programme-workout-progress-data'
import { useMemo } from 'react'

export type UseProgrammeProgressCountsResult = {
  completedClassesCount: number | undefined
  totalClassesCount: number | undefined
  isProgressReady: boolean
}

/**
 * Completion counts for a programme (completed / total). Uses the same completion rules as next-workout derivation.
 */
export const useProgrammeProgressCounts = (programmeId: string): UseProgrammeProgressCountsResult => {
  const { programmeWorkouts, completedProgrammeWorkouts, isQueriesFetched } = useProgrammeWorkoutProgressData(programmeId)

  return useMemo((): UseProgrammeProgressCountsResult => {
    if (!programmeId || !isQueriesFetched) {
      return {
        completedClassesCount: undefined,
        totalClassesCount: undefined,
        isProgressReady: false,
      }
    }
    const derived = deriveProgrammeWorkoutProgress(programmeWorkouts, completedProgrammeWorkouts)
    return {
      completedClassesCount: derived.completedClassesCount,
      totalClassesCount: derived.totalClassesCount,
      isProgressReady: true,
    }
  }, [programmeId, programmeWorkouts, completedProgrammeWorkouts, isQueriesFetched])
}
